import React from "react";
import { motion } from "framer-motion";
import AnimatedNumber from "../AnimatedNumber/AnimatedNumber";

interface ServiceCardProps {
  title: string;
  description: string;
  icon?: string; // SVG dosya yolu
  statValue?: number;
  statText?: string;
  text?: string[];
  gradient: string;
  iconColor?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ title, description, icon, statValue, statText, text, gradient, iconColor = "text-primaryPurple" }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.05, boxShadow: "0 8px 15px rgba(0,0,0,0.1)" }}
      transition={{ type: "spring", stiffness: 300 }}
      className="bg-white p-6 sm:p-10 rounded-lg shadow-md cursor-pointer flex flex-col h-full"
    >
      <div className="flex flex-col h-full">
        {icon && <img src={icon} alt={`${title} icon`} className={`mb-4 h-20 w-20`} />}

        <div className="flex-1">
          <h3 className={`text-xl sm:text-2xl md:text-3xl font-semibold mb-2 bg-gradient-to-r ${gradient} bg-clip-text text-transparent`}>{title}</h3>

          <p className="text-gray-700 text-base sm:text-lg md:text-xl mb-4">{description}</p>
        </div>

        {statValue !== undefined && (
          <div className="text-2xl sm:text-3xl md:text-4xl text-gray-700 mt-auto">
            <AnimatedNumber value={statValue} /> <span className="text-[24px]">{statText}</span>
          </div>
        )}

        {/* {text && (
          <ul className="text-gray-600 text-sm sm:text-base list-disc list-inside mt-2 space-y-1">
            {text.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        )} */}
      </div>
    </motion.div>
  );
};

export default ServiceCard;
